import { render, staticRenderFns } from "./AS_MobileUpdate.vue?vue&type=template&id=b7176038&scoped=true&"
import script from "./AS_MobileUpdate.vue?vue&type=script&lang=js&"
export * from "./AS_MobileUpdate.vue?vue&type=script&lang=js&"
import style0 from "./AS_MobileUpdate.vue?vue&type=style&index=0&id=b7176038&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7176038",
  null
  
)

export default component.exports